import store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'

import { routes as helpers			} from './helpers'
import { routes as powerbi			} from './modules/bi'
import { routes as configurations	} from './modules/configurations'
import { routes as customers		} from './modules/customers'
import { routes as dashboard		} from './modules/dashboard'
import { routes as launch			} from './modules/launch'
import { routes as marketing 	 	} from './modules/marketing'
import { routes as news 		 	} from './modules/news'
import { routes as openSearch 	 	} from './modules/openSearch'
import { routes as products 	 	} from './modules/products'
import { routes as reports 		 	} from './modules/reports'
import { routes as reserves 	 	} from './modules/reserves'
import { routes as chooseUnitReserve} from './modules/chooseUnitReserve'
import { routes as sales 		 	} from './modules/sales'
import { routes as tasks 		 	} from './modules/tasks'
import { routes as users 		 	} from './modules/users'
import { routes as profile			} from './profile'
import { routes as publicPages		} from './public'
import { routes as contracts		} from './modules/contracts'
import { routes as proposalGuide	} from './modules/proposalGuide'
import { routes as newReports    	} from './modules/newReports'
import { routes as digitalSignature } from './modules/digitalSignature'

import { facilita } from '@/global'
import { configuration } from '@/services/axios'
import { storage } from '@/services/storage'
import helpersMixin from '@/mixins/helpers'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: facilita.devHost,
	routes: [
		{
			path: '*',
			redirect: { name: 'errors.not.found' }
		},
		{
			path: '/logout',
			beforeEnter: () => {
				store.dispatch('auth/clearUserData')
			},
			meta: {
				title: (storage.get('client_name') || 'Facilita') + ' - Dashboard',
			}
		},
		...profile,
		...publicPages,
		...dashboard,
		...helpers,
		...marketing,
		...products,
		...sales,
		...tasks,
		...users,
		...powerbi,
		...openSearch,
		...configurations,
		...reports,
		...reserves,
		...chooseUnitReserve,
		...contracts,
		...customers,
		...news,
		...launch,
		...proposalGuide,
		...newReports,
		...digitalSignature
	],
})

router.beforeEach(async (to, from, next) => {
	/**
	 * Caso esteja acessando a Dashboard, recarrega as configurações. Com exceção
	 * de quando se vem da tela de login, da própria Dashboard (refresh). As
	 * configurações são carregadas vindo da tela de login, quando a configuração
	 * de logo não estiver presente.
	 */
	if (to.path === '/' &&
		(!['/login', '/'].includes(from.path) ||
			(from.path === '/login' && !storage.get('client_logo')))) {
		await addStorage()
	}

	// Remove o iframe do painel legado caso der algum erro no modal
	if (to.path == '/') {
		const event = new CustomEvent('iframe--request-modal')
		window.parent.document.dispatchEvent(event)
	}

	/**	Caso o usuário logado não seja de um dos grupos permitidos redireciona este ao painel antigo */
	let go = true /** Flag que permite ou impede a visualisação da view */
	if (to.meta.rules) {
		const user = JSON.parse(storage.get('user_logged'))
		const userChoice = JSON.parse(storage.get('user_choice'))
		let goLegacy = userChoice && userChoice.type === 'legacy' && userChoice.route === to.name && to.name !== 'dashboard'
		if (user && (!to.meta.rules.groups.includes(user.user_group) || goLegacy)) {
			if (to.meta.rules.groups.includes('dinamic') && user.isDynamicGroup) {
				go = true

			} else {
				go = false
				router.push({ ...to.meta.rules.redirect }).catch(() => {
					try {
						/**
						 * Verifica se a rota de redirecionamento foi passada como um objeto, e realiza o parse
						 * para obter o caminho caso tenha sido
						 */
						const redirectHref = typeof to.meta.rules.redirect === 'object'
							? router.resolve(to.meta.rules.redirect).href
							: to.meta.rules.redirect
						location.replace(redirectHref)
					} catch (error) {
						Vue.prototype.$toastr.e(`Falha ao obter a URL de redirecionamento da rota: ${to.name}`)
					}
				})
			}
		}
	}

	if (to.meta.permissions) {
		const user = JSON.parse(storage.get('user_logged'))
		const userChoice = JSON.parse(storage.get('user_choice'))
		let goLegacy = userChoice && userChoice.type === 'legacy' && userChoice.route === to.name && to.name !== 'dashboard'
		/**
		 * Dá parse e Filtra o JSON de permissions do usuario, vindo do localstorage 
		 * e retorna os que possuem value =1
		 */
		const userPermissions = user.permissions ? JSON.parse(user.permissions) : {}
		const filteredAllowedPermissions = Object.keys(userPermissions)
			.filter(key => parseInt(userPermissions[key]))
		/**
		 * verifica se alguma das permissions esta dentro do array de permissions no route.
		 * meta.permissions
		*/
		const haveSuperAdminPermission = to.meta.permissions.permissions?.length 
			? filteredAllowedPermissions.find(permission => { 
				return to.meta.permissions.permissions?.includes(permission)
			})
			: true

		if (user &&
			(to.meta.permissions.groups.includes(user.user_group) ||
				goLegacy ||
				!haveSuperAdminPermission )) {
			go = false
			router.push({...to.meta.permissions.redirect}).catch(() => {
				try {
					/**
					 * Verifica se a rota de redirecionamento foi passada como um objeto, e realiza o parse
					 * para obter a URL caso tenha sido
					 */
					const redirectHref = typeof to.meta.permissions.redirect === 'object'
						? router.resolve(to.meta.permissions.redirect).href
						: to.meta.permissions.redirect

					location.replace(redirectHref)
				} catch (error) {
					Vue.prototype.$toastr.e(`Falha ao obter a URL de redirecionamento da rota: ${to.name}`)
				}
			})
		}
	}

	if (to.meta.noscroll) {
		document.body.classList.add('no-scroll')

	} else {
		document.body.classList.remove('no-scroll')
	}

	// Seta o cancelToken para cancelar todas as requisiçõens ao trocar de página
	const components = router.getMatchedComponents(to);
	components.forEach((component) => {
		if (component instanceof Vue) {
			// Chama o método $destroy para destruir a instância do componente
			component.$destroy();
		}
		// Limpeza específica do componente (exemplo: cancelar requisições, liberar recursos, etc.)
		// ...
	});

	if (go) {
		if(from.name) document.dispatchEvent(new CustomEvent('abortInPluginAxios'));

		if (to.meta.protect) {
			let checkAuth = await store.dispatch('auth/authExists')
			checkAuth ? next() : next('/login')
		} else {
			next()
		}
	}

	let clientName = storage.get('client_name') || 'Facilita'
	document.title = to.meta.title || clientName + ' - Entrar'

})

function addStorage() {
	return configuration.getConfigurations()
		.then(response => {
			let clubpoints = {}
			let configsData = {}
			for (const config of response.data) {
				configsData[config.name] = config.value || config.value_long

				switch (config.name) {
					case 'nameBusiness':
						storage.set('client_name', config.value)
						break
				
					case 'clubName':
						clubpoints.name = config.value
						break

					case 'clubPoints':
						clubpoints.status = config.value
						break
					
					case 'clubPointsName':
						clubpoints.points_label = config.value
						storage.set('club', JSON.stringify(clubpoints))
						break
					
					case 'menuAllowed':
						storage.set('allowed_menu', config.value_long)
						break

					case 'brandLogo':
						storage.set('client_logo', helpersMixin.methods.getImgCDN(config.value))
						break

					case 'api_data':
						storage.set('api_config', JSON.stringify(config.value_long))
						break

					case 'allowedApps':
						storage.set('allowed_apps', config.value_long)
						break
					
					case 'proposalSettings':
						storage.set('proposal_settings', JSON.stringify(config.value_long))
						break
					
					case 'brokerApprove':
						storage.set('broker_approve', config.value)
						break
					
					case 'fieldIdentifier':
						storage.set('field_identifier', config.value)
						break
					
					case 'configsQueueReserves':
						storage.set('configs_queue_reserves', JSON.stringify(config.value_long))
						break
					
					case 'labelBroker':
						storage.set('label_broker', config.value)
						break

					case 'labelManager':
						storage.set('label_manager', config.value)
						break

					case 'labelSupervisor':
						storage.set('label_supervisor', config.value)
						break

					case 'labelCollaborator':
						storage.set('label_collaborator', config.value)
						break

					case 'labelAdmin':
						storage.set('label_admin', config.value)
						break

					case 'funnelMongo':
						storage.set('funnel_mongo', JSON.stringify(config.value_long))
						break
					
					case 'cacheVersion':
						storage.set('cache_version', config.value)
						break
					
					case 'configMirrorFacilita':
						storage.set('config_mirror_facilita', JSON.stringify(config.value_long))
						break

					case 'betaFeatures':
						storage.set('beta_features', JSON.stringify(config.value_long))
						break
					
					case 'dataReserve':
						storage.set('data_reserve', JSON.stringify(config.value_long))
						break
					
					case 'dataPreSales':
						storage.set('data_pre_sales', JSON.stringify(config.value_long))
						break

					case 'fieldCpf':
						storage.set('field_cpf', config.value)
						break
				}
			}

			storage.set('get-configs-data',JSON.stringify(configsData))
		})
		.catch(error => {
			if (error?.data?.msg) this.$toastr.e(error.data.msg)
		})
}

export default router
